<template>
    <div class="button-wrapper" :class="propsClass">
        <button class="button">test1</button>
    </div>
</template>
<script>
    export default {
        props:{
            propsClass: {
                type: String,
            }
        },
        name:"wheelButton"
    }
</script>
<style lang="scss">
    .button-wrapper{
        border: 1px solid red;
        & .button{
            color: red;
        }
    }
</style>